import moment from 'moment';

const today = moment().toISOString();

const formatDateDDMMYYYY = (date?: string | Date | null): string => {
  if (!date) return '-';
  return moment(date).format('DD/MM/YYYY');
};

// ======================
// PET AGE / PERSON AGE LIMITS
// ======================
const minDatePet = moment().subtract(9, 'years').toISOString();
const maxDatePet = moment().subtract(3, 'months').toISOString();
const mustBeAdult = moment().subtract(18, 'years').toISOString();

// ======================
// CREDIT CARD DATE LIMITS
// ======================
const minDateCreditCard = moment().add(1, 'month').toISOString();
const maxDateCreditCard = moment().add(20, 'years').toISOString();

export {
  today,
  formatDateDDMMYYYY,
  minDatePet,
  maxDatePet,
  mustBeAdult,
  minDateCreditCard,
  maxDateCreditCard,
};
